import * as React from "react";
import * as _ from "lodash"
import { IPatientAllergy } from "@curefit/ehr-common";
import {IPatientVitalResponse} from "../../../models/IPatientVitalResponse"
import AppUtils from "../../../utils/AppUtils"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader";
import {AppMessages} from "../../../utils/AppConstants";

/**
 * Created by aditya on 06/02/18.
 */

// const VitalsToShow = ["BMI", "BP", "PULSE RATE", "RESPIRATORY RATE", "TEMPERATURE", "SPO2", "WHR", "HEIGHT", "WEIGHT"];
const VitalsToShow = ["SYSTOLIC BP", "DIASTOLIC BP", "TEMPERATURE", "PULSE RATE", "SPO2", "RESPIRATORY RATE", "WEIGHT", "HEIGHT", "BMI", "WHR" ];
const VitalToHeaderMap = [{name: "SYSTOLIC BP", header: "SBP", unit: "(mmhg)"},
                            {name: "DIASTOLIC BP", header: "DBP", unit: "(mmhg)"},
                            {name: "TEMPERATURE", header: "TEMP.", unit: "(F)"},
                            {name: "PULSE RATE", header: "PR", unit: "/MIN"},
                            {name: "SPO2", header: "SPO2", unit: "(RA)"},
                            {name: "RESPIRATORY RATE", header: "RR", unit: "/MIN"},
                            {name: "WEIGHT", header: "WEIGHT", unit: "(Kg)"},
                            {name: "HEIGHT", header: "HEIGHT", unit: "(cm)"},
                            {name: "BMI", header: "BMI", unit: "(Kg/m2)"},
                            {name: "WHR", header: "WHR", unit: ""}]

export interface PatientVitalsSummaryBarProps {
    patientVitals: IPatientVitalResponse[];
    patientAllergies?: IPatientAllergy[];
    fetchVitals?: () => void
}


export interface PatientVitalsSummaryBarState {

}

class PatientVitalsSummaryBar extends React.Component<PatientVitalsSummaryBarProps, PatientVitalsSummaryBarState> {

    constructor(props: PatientVitalsSummaryBarProps) {
        super(props);
    }

    componentDidMount() {
        if (this.props.fetchVitals && _.isEmpty(this.props.patientVitals)) {
            this.props.fetchVitals();
        }
    }

    getSortedVitals = () => {
        let orderedVitals: IPatientVitalResponse[] = [];
        _.map(VitalsToShow, (vitalName: string) => {
            let requiredVital = this.props.patientVitals ? this.props.patientVitals.filter(item => item.vitalName && item.vitalName.toUpperCase() === vitalName) : [];
            if (requiredVital.length) {
                orderedVitals.push(requiredVital[0])
            }
        })
        return orderedVitals;
    }

    getHeaderInfo = (sortedVitals: IPatientVitalResponse[]) => {
        let VitalsHeaderInfos: ICustomHeaderInfo[] = [];
        _.map(sortedVitals, function(patientVital: IPatientVitalResponse, index) {
            if (VitalsToShow.indexOf(patientVital.vitalName.toUpperCase()) !== -1) {
                let headerItem = VitalToHeaderMap.filter(item => item.name === patientVital.vitalName.toUpperCase())[0];
                let vitalHeaderDisplay = headerItem.header + " " + headerItem.unit;
                VitalsHeaderInfos.push({label: patientVital.vitalName.toLowerCase(), display: vitalHeaderDisplay})
            }
        });
        return VitalsHeaderInfos;
    }

    render() {
        let allergiesCount = this.props.patientAllergies !== undefined && this.props.patientAllergies !== null ? this.props.patientAllergies.length : 0;
        let vitalsCount = this.props.patientVitals !== undefined && this.props.patientVitals !== null ? this.props.patientVitals.length : 0;
        let sortedVitals = this.getSortedVitals();
        let VitalsHeaderInfos: ICustomHeaderInfo[] = this.getHeaderInfo(sortedVitals);
        return (
            <div className="vitals-summary-bar">
                <CustomHeader headerInfos={VitalsHeaderInfos} rootCls={"patient-vitals"}/>
                {
                    vitalsCount ?
                    <div className="vitals-wrapper">
                        {
                            _.map(sortedVitals, function (patientVital: IPatientVitalResponse, index) {
                                let patientCurrVitalText = AppUtils.sortPatientVitalHistory(patientVital.vitalHistoryList)[0].value;
                                let formattedVitalValue = !isNaN(Number(patientCurrVitalText)) && Number(patientCurrVitalText) % 1 !== 0 ? Number(patientCurrVitalText).toFixed(2) : patientCurrVitalText;
                                return (
                                    <div
                                        className={`patient-vitals in-blk mid-align vital-summary-bar-${patientVital.vitalName.toLowerCase().replace(/ /g, "")}`}
                                        key={index}>
                                        <span className="vital-current pull-left"> {formattedVitalValue} </span>
                                    </div>
                                )
                            })
                        }
                    </div> : <div>{AppMessages.VITALS_SUMMARY_BAR_NO_VITALS}</div>
                }
                {
                    allergiesCount ?
                    <div className={"allergies-summary-container"}>
                        <span className={"allergies-label brandon-bold"}>ALLERGIES : </span>
                        {
                            _.map(this.props.patientAllergies, (allergy, index) => {
                                return index === (allergiesCount - 1) ? allergy.displayValue : `${allergy.displayValue}, `
                            })
                        }
                    </div> : ""
                }
            </div>
        );
    }
}

export default PatientVitalsSummaryBar